import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import styled from 'styled-components';
import React, { useContext, useRef, useState, useCallback, useEffect } from 'react';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../utils/responsive.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import { useOnClickOutside } from '../../hooks/useOnClickOutside/useOnClickOutside.es.js';
import '@popperjs/core';
import '../../utils/assertions.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import 'react-beautiful-dnd';
import 'use-callback-ref';
import 'nanoid/non-secure';
import { TableSemanticContext } from './TableSemanticContext.es.js';
import { TableContext } from './TableContext.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var Body = styled(Box).withConfig({
  componentId: "j0vyu3-0"
})(["display:table-row-group;"]);

var TableBody = function TableBody(_a) {
  var _b = _a,
      children = _b.children,
      rowsCount = _b.rowsCount,
      props = __objRest(_b, ["children", "rowsCount"]);

  var _useContext = useContext(TableContext),
      setBodyNode = _useContext.setBodyNode,
      dispatchRowChangedEvent = _useContext.dispatchRowChangedEvent,
      onRowChange = _useContext.onRowChange,
      listenKeyEvents = _useContext.listenKeyEvents,
      focusedRowIndexRef = _useContext.focusedRowIndexRef;

  var tableRef = useRef(null);

  var _useState = useState(rowsCount || 0),
      childrenCount = _useState[0],
      setChildrenCount = _useState[1];

  var handleRowChange = useCallback(function (newRowIndex, event) {
    event == null ? void 0 : event.preventDefault();
    dispatchRowChangedEvent(newRowIndex, (event == null ? void 0 : event.type) === "keydown");
    onRowChange && onRowChange(newRowIndex, event);
  }, [onRowChange, dispatchRowChangedEvent]);
  var handleKeyDown = useCallback(function (event) {
    var newRowIndex = -1;

    switch (event.key) {
      case "ArrowDown":
        newRowIndex = Math.min(focusedRowIndexRef.current + 1, childrenCount);
        handleRowChange(newRowIndex, event);
        break;

      case "ArrowUp":
        newRowIndex = Math.max(focusedRowIndexRef.current - 1, -1);
        handleRowChange(newRowIndex, event);
        break;
    }
  }, [childrenCount, focusedRowIndexRef, handleRowChange]);
  var handleClickOutside = useCallback(function () {
    handleRowChange(-1);
  }, [handleRowChange]);
  useEffect(function () {
    if (children) {
      setChildrenCount(rowsCount || React.Children.count(children));
    }
  }, [children, rowsCount]);
  useEffect(function () {
    if (listenKeyEvents) {
      window.addEventListener("keydown", handleKeyDown);
    }

    return function () {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [listenKeyEvents, handleKeyDown]);
  useOnClickOutside(tableRef, handleClickOutside);
  useEffect(function () {
    setBodyNode(tableRef.current);
  }, [setBodyNode]);
  return (
    /* @__PURE__ */
    React.createElement(TableSemanticContext.Provider, {
      value: {
        location: "body"
      }
    },
    /* @__PURE__ */
    React.createElement(Body, __spreadValues({
      ref: tableRef
    }, props), children))
  );
};

export { TableBody };